module.exports = __webpack_public_path__ + "static/media/microphone.575d6cde.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/story/bg/microphone.jpeg
// module id = 80
// module chunks = 0